export const UGC_SELECTOR = 'js-ugc-selector';
export const UGC_SELECTOR_ITEM = 'js-ugc-selector-item';
export const UGC_SELECTOR_FEED = 'js-ugc-selector-feed';
export const UGC_SELECTOR_FEED_ACTIVE = 'ugc-selector__feed--active';
export const UGC_SELECTOR_ITEM_ACTIVE = 'ugc-selector__name--active';
